export function getAddress(value) {
  return `${value.city}, ${value.state}`
}
